import { combineReducers } from 'redux';
import { Filters } from './fieldsConfig';
import { ProfileFields } from './profileFields';
import { Alert } from './alert';
import { Feedback } from './feedback';

export const Common = combineReducers({
  Filters,
  ProfileFields,
  Alert,
  Feedback,
});
